module.exports = __webpack_public_path__ + "img/69147c0.jpg";